import { useRef } from "react";

import { ConsolePageModalContainer } from "./styles";

interface IConsolePageModalProps {
  children: React.ReactNode;
  handleCloseModal: VoidFunction;
  isOpen: boolean;
  maxWidth?: string;
}

export const ConsolePageModal = ({
  children,
  handleCloseModal,
  isOpen,
  maxWidth,
}: IConsolePageModalProps) => {
  const backgroundRef = useRef<HTMLDivElement>(null);

  const handleBackgroundClick = ({ target }) => {
    const clickedInBackground = target === backgroundRef.current;
    if (clickedInBackground) handleCloseModal();
  };

  return (
    <ConsolePageModalContainer
      ref={backgroundRef}
      onClick={handleBackgroundClick}
      isOpen={isOpen}
      maxWidth={maxWidth}
    >
      <div className="modal-content">{children}</div>
    </ConsolePageModalContainer>
  );
};
